var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-card',{attrs:{"title":"Dados Principais","exclude":_vm.exclude,"optional":_vm.optional}},[_c('crud-pessoa-juridica-base',{attrs:{"optional":_vm.optional,"exclude":_vm.exclude,"not-editable":_vm.notEditable}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }